import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { IoChevronDown } from "react-icons/io5";
import Details from "./Details";
import config from "../../config";

const BasketStockPerformance = ({ togglePerformanceReport, basketId }) => {

  const [err, setErr] = useState("")
  const [basketStockList, setBasketStockList] = useState([])
  const [sortBy, setSortBy] = useState("dateDesc")
  const [isSortMenuOpen, setIsSortMenuOpen] = useState(false)

  const sortOptions = [
    { value: "dateDesc", label: "Date: Latest First" },
    { value: "dateAsc", label: "Date: Oldest First" },
    { value: "gainers", label: "Gainers First" },
    { value: "losers", label: "Losers First" },
  ];

  useEffect(() => {
  console.log("basketId", basketId);
    const getBasketPerformanceData = async (e) => {
      try {
        const res = await axios.get(config.BL_API_URL+"/basketstock/v1/getBasketStockPerformance", { params: { basketId } });

        if (res.data) {
          setBasketStockList(res.data)
         
        }
        else
          setErr("backend error")

      } catch (err) {
        console.log("first")
        if (err.response)
          setErr(err.response.data);
        else
          setErr("Server error...");
      }
    }

    getBasketPerformanceData(basketId);
  }, [basketId])

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (!event.target.closest("[data-sort-menu='basket-performance']")) {
        setIsSortMenuOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsSortMenuOpen(false);
      }
    };

    document.addEventListener("click", handleDocumentClick, true);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("click", handleDocumentClick, true);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);



  const closeButtonHandle = () => {
    togglePerformanceReport()
  }

  const selectedSortLabel = sortOptions.find((option) => option.value === sortBy)?.label || "Sort";

  const handleSelectSort = (value) => {
    setSortBy(value);
    setIsSortMenuOpen(false);
  };

  const getIsoDate = (value) => {
    if (!value) return "";
    const raw = String(value).trim();
    const yyyyMmDd = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (yyyyMmDd) {
      return `${yyyyMmDd[1]}-${yyyyMmDd[2]}-${yyyyMmDd[3]}`;
    }

    const ddMmmYyyy = raw.match(/^(\d{2})-([A-Za-z]{3})-(\d{4})$/);
    if (ddMmmYyyy) {
      const monthMap = {
        Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
        Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
      };
      const month = monthMap[ddMmmYyyy[2]];
      return month ? `${ddMmmYyyy[3]}-${month}-${ddMmmYyyy[1]}` : "";
    }

    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) {
      return "";
    }
    const year = parsed.getFullYear();
    const month = String(parsed.getMonth() + 1).padStart(2, "0");
    const day = String(parsed.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getDateTimestamp = (value) => {
    const iso = getIsoDate(value);
    if (!iso) return 0;
    const ts = new Date(`${iso}T00:00:00`).getTime();
    return Number.isNaN(ts) ? 0 : ts;
  };

  const sortedBasketStockList = [...(basketStockList || [])].sort((a, b) => {
    if (sortBy === "dateAsc") {
      return getDateTimestamp(a?.inceptionDate) - getDateTimestamp(b?.inceptionDate);
    }
    if (sortBy === "dateDesc") {
      return getDateTimestamp(b?.inceptionDate) - getDateTimestamp(a?.inceptionDate);
    }
    if (sortBy === "gainers") {
      return Number(b?.percentage || 0) - Number(a?.percentage || 0);
    }
    if (sortBy === "losers") {
      return Number(a?.percentage || 0) - Number(b?.percentage || 0);
    }
    return 0;
  });



  return (
    <div id="authentication-modal" tabIndex="-1" className="app-modal-overlay">
      <div className="relative w-full flex justify-center">
        <div className="border border-gray-200 w-full max-w-[760px] mx-auto relative bg-formbackground rounded-lg shadow-2xl app-modal-card">
          <div className="flex items-center justify-between p-3 border-b rounded-t sticky top-0 bg-formbackground z-10">
            <h3 className="text-base sm:text-xl font-semibold text-gray-900">Basket Performance Report</h3>
            <button onClick={() => closeButtonHandle()} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center" data-modal-hide="authentication-modal">
              <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>

          <div className="px-3 sm:px-4 pt-3 pb-2 border-b bg-formbackground">
            <div className="flex flex-col sm:flex-row sm:items-end gap-2">
              <div className="w-full sm:w-auto">
                <label className="block text-xs uppercase tracking-wide text-gray-500 mb-1">Sort</label>
                <div className="relative w-full sm:w-[230px]" data-sort-menu="basket-performance">
                  <button
                    type="button"
                    onClick={() => setIsSortMenuOpen((prev) => !prev)}
                    className="w-full rounded-md border border-gray-300 px-2.5 py-2 text-sm bg-white text-left flex items-center justify-between"
                    aria-haspopup="listbox"
                    aria-expanded={isSortMenuOpen}
                  >
                    <span className="truncate">{selectedSortLabel}</span>
                    <IoChevronDown className={`h-4 w-4 text-gray-500 transition-transform ${isSortMenuOpen ? "rotate-180" : ""}`} />
                  </button>

                  {isSortMenuOpen && (
                    <div className="absolute left-0 right-0 mt-1 rounded-md border border-gray-200 bg-white shadow-lg z-20 overflow-hidden" role="listbox">
                      {sortOptions.map((option) => (
                        <button
                          key={option.value}
                          type="button"
                          onClick={() => handleSelectSort(option.value)}
                          className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 ${sortBy === option.value ? "bg-gray-100 font-semibold text-gray-900" : "text-gray-700"}`}
                        >
                          {option.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="p-2 sm:p-4">
            <div className="max-h-[calc(100dvh-220px)] overflow-y-auto pr-1">
              {sortedBasketStockList && sortedBasketStockList.length > 0 &&
                sortedBasketStockList.map((item, index) => (
                  <Details key={`${item?.scripName || "item"}-${index}`} item={item} />
                ))}

              {(!sortedBasketStockList || sortedBasketStockList.length === 0) && (
                <div className="py-8 px-2 flex justify-center items-center">
                  <span className="text-base sm:text-lg text-gray-600">No data to display.</span>
                </div>
              )}

              {err && (
                <div className="py-2 px-2 text-center text-red-500 text-sm">{err}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default BasketStockPerformance;